import {
  IEntityUser,
  IPaginatedResponse,
  IUserAccount,
} from '@boma/client-shared';
import { createAction, props } from '@ngrx/store';
import { UserFilters } from './users.reducer';

// GET - User Index
export const loadUsers = createAction(
  '[Users] Load Users',
  props<UserFilters>()
);

export const loadUsersSuccess = createAction(
  '[Users] Load Users Success',
  props<{ payload: IPaginatedResponse<IEntityUser> }>()
);

export const loadUsersFailure = createAction(
  '[Users] Load Users Failure',
  props<{ error: any }>()
);

export const loadArchivedUsers = createAction(
  '[Users] Load Filtered Users',
  props<UserFilters>()
);

export const loadArchivedUsersSuccess = createAction(
  '[Users] Load Filtered Users Success',
  props<{ payload: IPaginatedResponse<IEntityUser>; filters: UserFilters }>()
);

export const loadArchivedUsersFailure = createAction(
  '[Users] Load Filtered Users Failure',
  props<{ error: any }>()
);

export const restoreArchivedUser = createAction(
  '[Users] Restore Archived User',
  props<{ userId: string }>()
);

export const restoreArchivedUserSuccess = createAction(
  '[Users] Restore Archived User Success',
  props<{ payload: IEntityUser }>()
);

export const restoreArchivedUserFailure = createAction(
  '[Users] Restore Archived User Failure',
  props<{ error: any }>()
);

// GET - User Entity
export const getUserEntity = createAction(
  '[Users] Load User Entity',
  props<{ entityId: string; userId: string }>()
);

export const getUserEntitySuccess = createAction(
  '[Users] Load User Entity Success',
  props<{ payload: IEntityUser }>()
);

export const getUserEntityFailure = createAction(
  '[Users] Load User Entity Failure',
  props<{ error: any }>()
);

// GET - User Account
export const getUserAccount = createAction(
  '[Users] Load User Account',
  props<{ emailAddressOrPhoneNumber: string }>()
);

export const getUserAccountSuccess = createAction(
  '[Users] Load User Account Success',
  props<{ payload: IUserAccount }>()
);

export const getUserAccountFailure = createAction(
  '[Users] Load User Account Failure',
  props<{ error: any }>()
);

// POST - Update User Entity
export const updateUserEntity = createAction(
  '[Users] Update User Account',
  props<{ entityId: string; userId: string; data: IEntityUser }>()
);

export const updateUserEntitySuccess = createAction(
  '[Users] Update User Account Success',
  props<{ payload: IEntityUser }>()
);

export const updateUserEntityFailure = createAction(
  '[Users] Update User Account Failure',
  props<{ error: any }>()
);

// POST - User Account
export const createUserAccount = createAction(
  '[Users] Create User Account',
  props<{ user: IEntityUser }>()
);

export const createUserAccountSuccess = createAction(
  '[Users] Create User Account Success',
  props<{ payload: IEntityUser }>()
);

export const createUserAccountFailure = createAction(
  '[Users] Create User Account Failure',
  props<{ error: any }>()
);

export const deleteUser = createAction(
  '[Users] Delete User Account',
  props<{ userId: string }>()
);
export const deleteUserSuccess = createAction(
  '[Users] Delete User Account Success',
  props<{ userId: string }>()
);
export const deleteUserFailure = createAction(
  '[Users] Delete User Account Failure',
  props<{ userId: string; error: any }>()
);
